export const StringUtils = {
    removeWhitespace(input: string): string {
        return input.replace(/\s/g, '');
    },
};
